import { Alert, Box, useMediaQuery } from "@mui/material";
import {
  DeleteBuilderButton,
  AddBuilderButton,
} from "../../Builder/Common/CommonBuilderComponent";
import DocumentList from "../../Builder/BuilderCard/DocumentList";
import "./PageDetails.css";
import { useFormContext, useFieldArray } from "react-hook-form";
import { TextArea, TextInput } from "pepsico-ds";
import "./Sections.css";
import { useState } from "react";

const Sections = ({
  dragHandleProps,
  sectionId,
  handleRemoveSection,
  setOpenModal,
  setSelectSectionId,
  selectionId,
  index,
}) => {
  const isMobile = useMediaQuery("(max-width:940px)");
  const [duplicateSection, setDuplicateSection] = useState(false);

  const {
    setValue,
    trigger,
    getValues,
    formState: { errors },
    watch,
  } = useFormContext();

  // Access fields from useFieldArray to check duplicates & get data
  const { fields, update } = useFieldArray({
    name: "sections",
  });

  const section = watch(`sections.${index}`);
  const sectionData = section?.data || [];

  const selectThisSection = () => setSelectSectionId(sectionId);
  const handleDelete = () => handleRemoveSection(sectionId);
  const handleOpen = () => setOpenModal(true);

  const handleSectionFieldChange = (field, value) => {
    // Check duplicates only for sectionName
    if (field === "sectionName") {
      const duplicate = getValues("sections").some(
        (s, idx) =>
          s.sectionName?.toLowerCase() === value.toLowerCase() && idx !== index
      );
      if (duplicate) {
        setDuplicateSection(true);
        return;
      }
      setDuplicateSection(false);
    }

    setValue(`sections.${index}.${field}`, value, { shouldValidate: true });
  };

  const handleMouseEnter = async () => {
    await trigger(`sections.${index}.sectionName`);
  };
  const sectionDatas = getValues("sections");

  const handleDeleteContent = (sectionId, contentId) => {
    const sectionIndex = fields.findIndex((f) => f.sectionId === sectionId);
    if (sectionIndex !== -1) {
      const updatedData = fields[sectionIndex].data.filter(
        (item) => item.contentId !== contentId
      );
      update(sectionIndex, { ...fields[sectionIndex], data: updatedData });
    }
  };

  return (
    <div className="w-full flex flex-col gap-4">
      <Box
        onMouseEnter={() => {
          selectThisSection();
          handleMouseEnter();
        }}
        onClick={selectThisSection}
        sx={{
          display: "flex",
          minHeight: "48px",
          p: "8px 0",
          justifyContent: isMobile ? "flex-start" : "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
          alignSelf: "stretch",
          borderRadius: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: isMobile ? "100%" : "400px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "24px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...dragHandleProps}
            style={{ cursor: "grab" }}
          >
            <path
              d="M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z"
              fill="#3A3A3A"
            />
          </svg>

          <TextInput
            className={`section ${
              errors?.sections?.[index]?.sectionName ? "section-error" : ""
            }`}
            name={`sections.${index}.sectionName`}
            label="Section title"
            value={getValues(`sections.${index}.sectionName`) || ""} // <-- autopopulate
            required
            style={{ width: isMobile ? "100%" : "400px" }}
            onChange={(e) =>
              handleSectionFieldChange("sectionName", e.target.value)
            }
          />
          {duplicateSection && (
            <Alert severity="error" sx={{ mt: 1, maxWidth: "350px" }}>
              Section title already exists
            </Alert>
          )}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
          <DeleteBuilderButton label="Remove section" onClick={handleDelete} />
          <AddBuilderButton
            label="Add content"
            onClick={handleOpen}
            type="button"
          />
        </Box>
      </Box>

      <TextArea
        data-testid="section-desc"
        name={`sections.${index}.sectionDescription`}
        label="Description"
        placeholder="Type here"
        showToolbar={false}
        onChange={(e) =>
          handleSectionFieldChange("sectionDescription", e.target.value)
        }
        value={getValues(`sections.${index}.sectionDescription`) || ""}
        className="page-text"
      />

      <DocumentList
        data={sectionData}
        pageType="PAGE_BUILDER"
        handleDeleteContent={(contentId) =>
          handleDeleteContent(sectionId, contentId)
        }
      />
    </div>
  );
};

export default Sections;
